// Design System v1.3 color theme
// Pre 2021 rebranding

[data-theme="inverse"] {
  --uui-color-aqua: #4cbaeb;
  --uui-color-sky: #9cdfff;
  --uui-color-sky-hover: #cff0ff;
  --uui-color-sky-active: #69cfff;
  --uui-color-frost: #cff0ff;
  --uui-color-frost-hover: #9ce0ff;
  --uui-color-frost-active: #69d0ff;
  --uui-color-bright-white: #ffffff;
  --uui-color-primary-white: rgba(255, 255, 255, 0.87);
  --uui-color-secondary-white: rgba(255, 255, 255, 0.6);
  --uui-color-ghost-btn-active: rgb(233, 248, 255, 0.5);
  --uui-color-ghost-btn-hover: rgb(233, 248, 255, 0.3);
  --uui-color-error-inverse: #f46665;

  --uui-theme-core-900: var(--uui-color-sky-active);
  --uui-theme-core-800: var(--uui-color-sky);
  --uui-theme-core-700: var(--uui-color-sky-hover);
  --uui-theme-core-600: var(--uui-color-frost-active);
  --uui-theme-core-500: var(--uui-color-frost);
  --uui-theme-core-400: var(--uui-color-frost-hover);

  --uui-theme-on-core-900: var(--uui-color-midnight);
  --uui-theme-on-core-800: var(--uui-color-midnight);
  --uui-theme-on-core-700: var(--uui-color-midnight);

  --uui-theme-on-core-600: var(--uui-color-pearl);
  --uui-theme-on-core-500: var(--uui-color-pearl);
  --uui-theme-on-core-400: var(--uui-color-midnight);

  --uui-theme-secondary-900: var(--uui-color-frost-active);
  --uui-theme-secondary-800: var(--uui-color-frost);
  --uui-theme-secondary-700: var(--uui-color-frost-hover);
  --uui-theme-secondary-400: var(--uui-color-primary-white);

  --uui-theme-on-secondary-900: var(--uui-color-midnight);
  --uui-theme-on-secondary-800: var(--uui-color-midnight);
  --uui-theme-on-secondary-700: var(--uui-color-midnight);

  --uui-theme-error-400: var(--uui-color-error-background);
  /* unspec'd */
  --uui-theme-error-500: var(--uui-color-error-dark);
  --uui-theme-error-600: var(--uui-color-error-inverse);
  --uui-theme-error-300: var(--uui-color-error-background);
  /* unspec'd */

  --uui-theme-warning-600: var(--uui-color-warning-dark);
  --uui-theme-warning-500: var(--uui-color-warning);
  --uui-theme-warning-400: var(--uui-color-warning-background);

  --uui-theme-success-600: var(--uui-color-success-dark);
  --uui-theme-success-500: var(--uui-color-success);
  --uui-theme-success-400: var(--uui-color-success-background);

  --uui-theme-variant-500: var(--uui-color-bright-white);
  --uui-theme-variant-600: var(--uui-color-bright-white);
  --uui-theme-variant-900: var(--uui-color-blue-active); /* Blue Active */
  --uui-theme-variant-800: var(--uui-color-blue); /* Blue */
  --uui-theme-variant-700: var(--uui-color-blue-hover); /* Blue Hover */
  --uui-theme-variant-200: var(--uui-color-bright-white);
  --uui-theme-variant-100: var(--uui-color-navy);

  --uui-theme-on-background: var(--uui-color-bright-white);
  --uui-theme-variant-400: var(--uui-color-secondary-white);
  /* box-shadow cannot use another variable. This is --uui-color-midnight */
  --uui-box-shadow-color: rgba(1, 22, 65, 255);

  /* control-specific theming */
  --uui-cb-checkbox-icon-url: url('data:image/svg+xml; utf8, <svg id="solid-check" fill="%23011641" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"/></svg>');
  --uui-panel-title-icon-collapsed: url('data:image/svg+xml; utf8, <svg fill="%239cdfff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20px" height="20px"><path d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"/></svg>');
  --uui-panel-title-icon-expanded: url('data:image/svg+xml; utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20px" height="20px" fill="white"><path d="M6.101 359.293L25.9 379.092c4.686 4.686 12.284 4.686 16.971 0L224 198.393l181.13 180.698c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 132.908c-4.686-4.686-12.284-4.686-16.971 0L6.101 342.322c-4.687 4.687-4.687 12.285 0 16.971z"/></svg>');
  --uui-panel-title-plus-icon: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="%239cdfff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M368 224H224V80c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h144v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V288h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"/></svg>');
  --uui-panel-title-minus-icon: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M368 224H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"/></svg>');

  --uui-icon-chevron-left: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="%23e5eff0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/></svg>');
  --uui-icon-chevron-left-hover: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="%23acc0c4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/></svg>');
  --uui-icon-chevron-right: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="%23e5eff0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/></svg>');
  --uui-icon-chevron-right-hover: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="%23acc0c4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/></svg>');
  --uui-icon-ellipsis-h: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="%23e5eff0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M192 256c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm88-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-240 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"/></svg>');
  --uui-icon-chevron-double-left: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="%23e5eff0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M349.5 475.5l-211.1-211c-4.7-4.7-4.7-12.3 0-17l211.1-211c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L178.1 256l195.5 195.5c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.6-12.3 4.6-17-.1zm-111 0l7.1-7.1c4.7-4.7 4.7-12.3 0-17L50.1 256 245.5 60.5c4.7-4.7 4.7-12.3 0-17l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0l-211.1 211c-4.7 4.7-4.7 12.3 0 17l211.1 211c4.8 4.8 12.4 4.8 17.1.1z"/></svg>');
  --uui-icon-chevron-double-left-hover: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="%23acc0c4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M349.5 475.5l-211.1-211c-4.7-4.7-4.7-12.3 0-17l211.1-211c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L178.1 256l195.5 195.5c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.6-12.3 4.6-17-.1zm-111 0l7.1-7.1c4.7-4.7 4.7-12.3 0-17L50.1 256 245.5 60.5c4.7-4.7 4.7-12.3 0-17l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0l-211.1 211c-4.7 4.7-4.7 12.3 0 17l211.1 211c4.8 4.8 12.4 4.8 17.1.1z"/></svg>');
  --uui-icon-chevron-double-right: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="%23e5eff0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M34.5 36.5l211.1 211c4.7 4.7 4.7 12.3 0 17l-211.1 211c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L205.9 256 10.5 60.5c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.6-4.6 12.2-4.6 16.9.1zm111 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17L333.9 256 138.5 451.5c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l211.1-211c4.7-4.7 4.7-12.3 0-17l-211.1-211c-4.8-4.8-12.4-4.8-17.1-.1z"/></svg>');
  --uui-icon-chevron-double-right-hover: url('data:image/svg+xml; utf8, <svg width="20px" height="20px" fill="%23acc0c4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M34.5 36.5l211.1 211c4.7 4.7 4.7 12.3 0 17l-211.1 211c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L205.9 256 10.5 60.5c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.6-4.6 12.2-4.6 16.9.1zm111 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17L333.9 256 138.5 451.5c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l211.1-211c4.7-4.7 4.7-12.3 0-17l-211.1-211c-4.8-4.8-12.4-4.8-17.1-.1z"/></svg>');

  /**tabs */
  uui-tabs {
    --uui-theme-core-800: var(--uui-color-bright-white);
  }

  /** expansion panel */
  uui-expansion-panel {
    --uui-theme-core-800: var(--uui-color-primary-white);
  }

  /** button tabs */
  uui-button-tabs {
    --uui-theme-on-core-900: var(--uui-color-midnight);
    --uui-theme-core-900: var(--uui-color-primary-white);
    --uui-theme-core-800: var(--uui-color-primary-white);
  }

  /** input description */
  uui-input-description {
    --uui-theme-variant-400: var(--uui-color-bright-white);
    --uui-input-description-opacity: var(--uui-opacity-lighter);
  }

  /** anchor, textarea tags */
  a,
  textarea,
  select,
  textarea {
    --uui-theme-core-600: var(--uui-color-sky-active);
    --uui-theme-core-500: var(--uui-color-sky);
    --uui-theme-core-400: var(--uui-color-sky-hover);
    --uui-theme-error-500: var(--uui-color-error-inverse);
  }

  textarea {
    --uui-theme-secondary-400: var(--uui-color-sky);
  }

  select {
    --uui-select-background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='16px' width='16px' viewBox='0 0 320 512'><path style='fill: rgb(207, 240, 255);' d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'/></svg>");
    --uui-select-svg-fill: var(--uui-color-frost);
    --uui-select-filter-brightness: brightness(2);
    --uui-theme-secondary-400: var(--uui-color-bright-white);
  }

  uui-input {
    --uui-theme-secondary-400: var(--uui-color-bright-white);
  }

  uui-tooltip {
    --uui-theme-on-core-700: var(--uui-color-bright-white);
  }

  uui-input-title {
    --uui-theme-error-500: var(--uui-color-error-inverse);
  }

  uui-input-error {
    --uui-theme-secondary-400: var(--uui-color-charcoal);
    --uui-theme-error-600: var(--uui-color-error-dark);
  }

  uui-filterchip {
    --uui-theme-core-500: var(--uui-color-bright-white);
    --uui-theme-core-600: var(--uui-color-sky-active);
    --uui-theme-core-400: var(--uui-color-sky-hover);
    --uui-theme-on-core-700: var(--uui-color-midnight);
  }
}
